export default class Loader {
    constructor(parent, router) {
        this.el = parent.el.querySelector('.fad-loader');
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
